/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.Model,
    mapping:{
        tabList:require('./TabList')
    },
    method:{
        init:function () {
            var tabList = this.get('tabList');
            tabList.onChange('activeIndex',function (inEvent,inIndex) {
                this.set('dataReady','loading');
                this.set('requireData',tabList._getItemModel(inIndex).get('status'),{skipSameValue:false});
            },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/tab/TapWrap.js
// module id = 44
// module chunks = 0 1 2 3 7 8 9 10 12 14 16 18 19 25 26 28 29 30